import DynamicModuleRegistrationUtil from '../utils/dynamicModuleRegistration'
import { store } from '../store'
import { CreateOrderEnum } from '../enums/modules/routes'

// Vuex Modules to load
const CreateOrdersStoreModule = () => import(/* webpackChunkName: "CreateOrder" */ '../store/modules/createOrder')

// Components to load
const CreateOrder = () => import(/* webpackChunkName: "CreateOrder" */ '@/components/createOrder/CreateOrder')
const OrderType = () => import(/* webpackChunkName: "CreateOrder" */ '@/components/createOrder/OrderType')
const Recipient = () => import(/* webpackChunkName: "CreateOrder" */ '@/components/createOrder/recipient/Recipient')
const CancelOrder = () => import(/* webpackChunkName: "CreateOrder" */ '@/components/createOrder/CancelOrder')
const ShippingMethod = () => import(/* webpackChunkName: "CreateOrder" */ '@/components/createOrder/shippingMethod/ShippingMethod.vue')
const PaymentMethod = () => import(/* webpackChunkName: "CreateOrder" */ '@/components/createOrder/paymentMethod/PaymentMethod.vue')
const PackingInstructions = () => import(/* webpackChunkName: "CreateOrder" */ '@/components/createOrder/packingInstructions/PackingInstructions.vue')
const AddProducts = () => import(/* webpackChunkName: "AddProducts" */ '@/components/createOrder/addProducts/AddProducts.vue')
const ShippingInformation = () => import(/* webpackChunkName: "ShippingInformaton" */ '@/components/createOrder/shippingInformation/ShippingInformation.vue')
const ReviewOrder = () => import(/* webpackChunkName: "ReviewOrder" */ '@/components/createOrder/reviewOrder/ReviewOrder.vue')
// ******************************************************
// *************** Route Guard Functions ****************
// ******************************************************

const dynamicModuleRegistrationOrdersArgs = () => {
  return {
    modulesNamespace: store._modulesNamespaceMap,
    moduleName: 'createOrder',
    module: CreateOrdersStoreModule,
    store,
    modulePath: 'createOrder',
    registerOptions: { preserveState: false }
  }
}

// ******************************************************
// ****************** Route Definitions *****************
// ******************************************************

export default [
  {
    path: '/CreateOrder',
    component: CreateOrder,
    name: CreateOrderEnum.CreateOrder,
    beforeEnter (_to, _from, next) {
      DynamicModuleRegistrationUtil(dynamicModuleRegistrationOrdersArgs()).then(
        () => next()
      )
    },
    children: [
      {
        path: 'OrderType',
        component: OrderType,
        name: CreateOrderEnum.OrderType
      },
      {
        path: 'Recipient',
        component: Recipient,
        name: CreateOrderEnum.Recipient
      },
      {
        path: 'CancelOrder',
        component: CancelOrder,
        name: CreateOrderEnum.CancelOrder
      },
      {
        path: 'ShippingType',
        component: ShippingMethod,
        name: CreateOrderEnum.ShippingMethod
      },
      {
        path: 'ShippingPayment',
        component: PaymentMethod,
        name: CreateOrderEnum.PaymentMethod
      },
      {
        path: 'Packing',
        component: PackingInstructions,
        name: CreateOrderEnum.PackingInstructions
      },
      {
        path: 'AddItems',
        component: AddProducts,
        name: CreateOrderEnum.AddProducts
      },
      {
        path: 'ShippingInformation',
        component: ShippingInformation,
        name: CreateOrderEnum.ShippingInformation
      },
      {
        path: 'Review',
        component: ReviewOrder,
        name: CreateOrderEnum.ReviewOrder
      }
    ]
  }
]
